import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { FiMenu, FiChevronDown } from "react-icons/fi";
import ContextDashboard from '../../Context/ContextDashboard';
import { getDashboardData } from '../../Utils/api';
import { getStorage } from '../../Utils/common';
import Avatar from '../Avatar/Avatar';
import urls from '../../Utils/urls';
import JourneyBar from '../JourneyBar/JourneyBar';
function DashboardHeader({
  toggle,
  setToggle
}) {
  const [dashboard, setDashboard] = useState([]);
  const [, forceRender] = useState(0);
  const {
    setProfileData
  } = useContext(ContextDashboard);
  const navigate = useNavigate();
  const fetchDashboard = () => {
    const params = {
      profile_id: getStorage("cust_profile_id") || ""
    };
    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setDashboard(dashboardData);
      }
    });
  };
  useEffect(() => {
    const handleProfileUpdated = () => {
      forceRender(n => n + 1);
      fetchDashboard();
    };
    fetchDashboard();
    window.addEventListener('profile-updated', handleProfileUpdated);
    return () => window.removeEventListener('profile-updated', handleProfileUpdated);
  }, []);
  const handleRightFlexClick = () => {
    const eligibility = getStorage('eligibility');
    if (eligibility === 1) {
      navigate('/my-dashboard/lead-preview');
    } else {
      navigate('/my-dashboard/profile-preview');
    }
  };
  const getProfilePictureUrl = profilePic => {
    if (!profilePic || typeof profilePic !== 'string' || profilePic.trim() === '') {
      return null;
    }
    
    profilePic = profilePic.trim();
    
    if (profilePic.startsWith('http')) {
      return profilePic;
    }

    if (profilePic.startsWith('direct-document-file/')) {
      profilePic = profilePic.replace('direct-document-file/', '');
    }

    return urls.PROFILE_PIC_BASE_URL + profilePic;
  };
  const rawName = getStorage("fullName") || dashboard?.Data?.profile_details?.first_name;
  const imgSrc = getProfilePictureUrl(dashboard?.Data?.profile_pic) || getProfilePictureUrl(dashboard?.Data?.profile_details?.profile_pic) || getProfilePictureUrl(dashboard?.Data?.profile_details?.selfie) || getProfilePictureUrl(dashboard?.Data?.profile_details?.selfie_doc_url) || getProfilePictureUrl(dashboard?.Data?.profile_details?.selfie_url) || getProfilePictureUrl(dashboard?.Data?.selfie) || getProfilePictureUrl(dashboard?.Data?.selfie_doc_url) || getProfilePictureUrl(dashboard?.Data?.selfie_url) || getProfilePictureUrl(getStorage("selfie")) || `https://ui-avatars.com/api/?name=${encodeURIComponent(getStorage("fullName") || dashboard?.Data?.profile_details?.first_name || "User")}&background=2889a6&color=fff`;
  return <header className={`modern_dash_header ${toggle ? "full" : ""}`}>
      <div className="header_left_action">
        <button className="menu_toggle_btn" onClick={() => setToggle(!toggle)}>
          <FiMenu />
        </button>
      </div>

      <JourneyBar />

      <div className="header_right_registry">
        <div className="header_user_profile" onClick={handleRightFlexClick}>
          <div className="user_avatar_wrap">
            <Avatar name={rawName} src={imgSrc} />
          </div>
          <div className="user_info_text">
            Hi, {(getStorage("fullName") || dashboard?.Data?.profile_details?.first_name || "Member")?.trim()?.split(" ")[0]}
          </div>
          <FiChevronDown style={{
            fontSize: '12px',
            opacity: 0.5
          }} />
        </div>
      </div>
    </header>;
}
export default DashboardHeader;